import { updateTagsSearchContext } from './update-tags-search-context';
export var searchClientResolvers = {
    Mutation: {
        updateTagsSearchContext: updateTagsSearchContext,
    },
};
//# sourceMappingURL=index.js.map